<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <h1 class="headline mb-1">Recargas a Planes</h1>
            <v-spacer></v-spacer>
              <v-text-field 
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details>
              </v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-2"  @click="crearPlan">Crear</v-btn>
          </v-card-title>
          <v-data-table 
            :headers="headers"
            :items="array_obj"
            :items-per-page="10"
            :search="search"
            class="elevation-1">
            <template v-slot:item.action="{ item }">
              <v-btn fab x-small @click="editar(item)" class="mr-2">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn fab x-small class="mr-2" @click="dialog=true;selected_id=item.id;">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.estado="{ item }">
                <v-chip v-if="item.estado == 'ACTIVO'" x-small color="success" text-color="white"> Activo </v-chip>
                <v-chip v-else x-small color="red" text-color="white"> Inactivo </v-chip>
            </template>
          </v-data-table>
        </v-card>

        <template>
          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline"></v-card-title>
                <v-card-text>Desea eliminar el item {{selected_id}}?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
                    <v-btn color="green darken-1" text @click="dialog = false;eliminar();  ">Si</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <v-dialog v-model="dialogForm" persistent max-width="600px">
          <v-card>
            <v-card-title class="headline">
              <span v-if="es_nueva">Nueva Recarga</span>  
              <span v-if="!es_nueva">Editar Recarga</span>  
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>

              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="planId" 
                    :items="array_planes"
                    class="mt-0 pt-0"
                    :item-text="planes.text"
                    :item-value="planes.value"
                    :rules="[rules.required]"
                    label="Plan Id"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="codigo_esb" 
                    class="mt-0 pt-0"
                    type="number"
                    :rules="[rules.required]"
                    label="Código Esb">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="descripcion" 
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Descripción">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="tipo" 
                    class="mt-0 pt-0"
                    :items="planes"
                    :item-text="planes.text"
                    :item-value="planes.value"
                    :rules="[rules.required]"
                    label="Tipo"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="unidades_adicionales" 
                    type="number"
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Unidades Adicionales">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="valor" 
                    class="mt-0 pt-0"
                    type="number"
                    :rules="[rules.required]"
                    label="Valor">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-radio-group v-model="estado"  column>
                    <v-radio label="Activo" value="ACTIVO"></v-radio>
                    <v-radio label="Inactivo" value="INACTIVO"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>  
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="reset"> Cerrar </v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" v-if="es_nueva" color="primary" class="mr-4" type="submit" @click="validate_and_save"> Grabar </v-btn>
              <v-btn :disabled="!valid" v-if="!es_nueva" color="primary" class="mr-4" type="submit" @click="validate_and_update"> Actualizar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-col>
  </v-row>
</v-container>
</template>
<script>

  import axios from "axios";
  export default {
    data () {
      return {
        search: "",
        dialog: false,
        selected_id: 0,
        notificacion_exito: false,
        headers: [
          // { text: 'Id', align: 'start', sortable: true, value: 'id' },
          { text: 'Nombre Plan', value: 'nombre_plan', sortable: true },
          { text: 'Descripción', value: 'descripcion', sortable: true },
          { text: 'Codigo Esb', value: 'codigo_esb', sortable: true },
          { text: 'Tipo', value: 'tipo', sortable: true },
          { text: 'Unidades Adicionales', value: 'unidades_adicionales', sortable: true },
          { text: 'Usuario Creación', value: 'usuario_creacion', sortable: true },
          { text: 'Usuario Actualizacion', value: 'usuario_actualizacion', sortable: true },
          { text: 'Valor', value: 'valor', sortable: true },
          { text: 'Fecha Alta', value: 'fecha_alta', sortable: true },
          { text: 'Fecha Actualización', value: 'fecha_actualizacion', sortable: true },
          { text: 'Estado', value: 'estado', sortable: true },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        planes: [
          { text: 'Reposición certificados', value: 'reposicion_certificados'},
          { text: 'Usuario Administrador', value: 'admin_user'},
          { text: 'Usuario Operador', value: 'operador_user'},
          { text: 'Estampado Adicional', value: 'estampado_adicional'},
          { text: 'Espacio Disponible(GB)', value: 'espacio_disponible'},
          { text: 'Flujo Adicional', value: 'flujo_adicional'},
          { text: 'Plantilla Adicional', value: 'plantilla_adicional'},
          { text: 'Correo Adicional', value: 'correo_adicional'},
        ],
        array_obj: [],
        array_planes: [],
        id: null,
        planId: null,
        codigo_esb: null,
        descripcion: null,
        valor: null,
        tipo: null,
        unidades_adicionales: 0,
        estado: "ACTIVO",
        valid: true,
        es_nueva: true,
        dialogForm: false,
        rules: {
          required: value => !!value || 'Campo Requerido.',
          positivo_mayor_cero: value =>  0 < Number(value) || 'Campo debe ser mayor a cero'
        },
      }
    },
    mounted() {
      console.log("parametros.vue");      
      this.getPlanes();
      this.getParametros();
    },
    methods: {
      getPlanes() {
        let _this = this;
        let getParametros = axios.get('Plan/listar', { 'headers': this.$store.state.user.headers });
        return getParametros.then((callback) =>
        {
          callback.data.forEach(function(item, i) {
            _this.array_planes.push({ text: item.nombre, value: item.id });
          })
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      eliminar() {
        console.log("Deleting Item id :" + this.selected_id)
        let getuser = axios.delete('Recarga/eliminar?id=' + this.selected_id,  { 'headers': this.$store.state.user.headers })
        return getuser.then((callback) => {
          console.log(callback.data)
          if(callback.status == 200) {
            console.log('Eliminando el item : ' + this.selected_id);
            this.array_obj.splice(this.array_obj.findIndex(e => e.id == this.selected_id), 1);
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
          } else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo error en el proceso' });
          }
        }).catch((error) => {
          console.log(error.response);
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo error en el proceso' });
        });
      },
      getParametros() {
        let getParametros = axios.get('Recarga/listar', { 'headers': this.$store.state.user.headers });
        return getParametros.then((callback) =>
        {
          this.array_obj = callback.data;
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      validate_and_save() {
        if (this.$refs.form.validate()) {
          this.dialogForm = false;
          this.$store.dispatch('SET_OVERLAY');

          let vm_data = {
            planId: this.planId,
            descripcion: this.descripcion,
            valor: Number(this.valor),
            valor: Number(this.valor),
            codigo_esb: this.codigo_esb,
            tipo: this.tipo,
            unidades_adicionales: Number(this.unidades_adicionales),
            estado: this.estado,
          };

          let getuser = axios.post('Recarga/Crear', vm_data, { 'headers': this.$store.state.user.headers })
          return getuser.then((callback) => {
            console.log(callback);
            if(callback.status ==201) {
              this.reset();
              let getMembresias = axios.get('Recarga/Recuperar/' + callback.data, { 'headers': this.$store.state.user.headers });
              return getMembresias.then((callback1) =>
              {
                if(callback1.status == 200) {
                  this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
                  this.array_obj.push(callback1.data);
                  this.$store.dispatch('UNSET_OVERLAY');
                }
              }).catch((error) => {
                this.dialogForm = true;
                this.$store.dispatch('UNSET_OVERLAY');
                console.log(error.response.data);
                this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 1: ' + error.response.data });
              });
            }
          }).catch((error1) => {
            this.dialogForm = true;
            console.log(error1.response.data);
            this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 2: ' + error1.response.statusText });
          });
        }
      },
      validate_and_update() {
        console.log("validate_and_update");
        if (this.$refs.form.validate()) {
          this.$store.dispatch('SET_OVERLAY');
          this.dialogForm = false;

          let vm_data = {
            planId: this.planId,
            descripcion: this.descripcion,
            valor: Number(this.valor),
            valor: Number(this.valor),
            tipo: this.tipo,
            codigo_esb: this.codigo_esb,
            id: this.id,
            unidades_adicionales: Number(this.unidades_adicionales),
            estado: this.estado,
          };

          let getuser = axios.put('Recarga/Actualizar', vm_data, { 'headers': this.$store.state.user.headers })
          return getuser.then((callback) => {
            if(callback.status == 200 ) {
              this.reset();
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
              this.getParametros();
            }
            this.$store.dispatch('UNSET_OVERLAY');
          }).catch((error) => {
            this.es_nueva = false;
            this.dialogForm = true;
            this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion: ' + error.response.data });
            console.log(error.response.data);
          });
        }
      },
      crearPlan(){
        this.dialogForm = true;
        this.es_nueva = true;
        this.$refs.form.reset();
      },
      editar(item) {
        console.log("editando");
        this.dialogForm = true;
        this.es_nueva = false;
        this.selected_id =item.id;
        Object.keys(item).forEach(key => {
           this.$set(this, key, item[key]);
        });
      },
      reset() {
        console.log("reset");
        this.es_nueva = true;
        this.dialogForm = false;  
      },
    }
  }
</script>